module.exports = __webpack_public_path__ + "media/images/icon__unlocked-c5c03ee3974a50450c1cc7e0eb5138fc.png";